<div class="page-content page-fill">
  <div class="grid-fill">
    <dx-data-grid #dataGrid [dataSource]="store" (onToolbarPreparing)="onToolbarPreparing($event)">
      <!-- <dxi-column dataField="id" cellTemplate="linkTemplate"></dxi-column> -->
      <dxi-column dataField="textGroupLinks[0].toGroup.name" caption="To"  cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="body" caption="Message"></dxi-column>
      <div *dxTemplate="let cell of 'linkTemplate'">
        <a [routerLink]="" (click)="openSents(cell.data)">{{ cell.value || '(blank)' }}</a>
      </div>
      <dxi-column dataField="created" format="shortDateShortTime" width="200px"></dxi-column>
      <dxi-column dataField="sent" format="shortDateShortTime" width="200px"></dxi-column>
      @if (auth.hasRole('Administrator')) {
        <dxi-column dataField="fromUser.userName" caption="Created By" ></dxi-column>
      }

      <dxo-paging [pageSize]="50" [enabled]="false"></dxo-paging>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button type="button" (click)="add()" class="btn btn-secondary ms-2">New</button>
      </div>
    </dx-data-grid>
  </div>
</div>
